import { createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = {
  key: 0,
  class: "card border"
}
const _hoisted_3 = { class: "card border" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = {
  class: "row align-items-center",
  style: {"min-height":"120px"}
}
const _hoisted_6 = {
  class: "col-5 text-center",
  style: {"padding":"0"}
}
const _hoisted_7 = {
  class: "fw-bold text-dark mb-1",
  style: {"font-size":"3.9rem"}
}
const _hoisted_8 = { class: "text-muted" }
const _hoisted_9 = {
  class: "col-5",
  style: {"padding":"0"}
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "h6 fw-bold mb-1 text-success" }
const _hoisted_12 = { class: "small text-muted" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { key: 4 }
const _hoisted_18 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_19 = {
  key: 1,
  class: "text-muted text-center py-4"
}
const _hoisted_20 = { class: "h6 fw-bold mb-1 text-success" }
const _hoisted_21 = { class: "small text-muted" }

import { ref, computed } from "vue";
import { useMyTransactionsQuery } from "../../api/queries/userQueries.js";
import VueCountdown from "@chenfengyuan/vue-countdown";
import { useFloating, autoUpdate, offset, flip, shift } from "@floating-ui/vue";

import { onMounted, onUnmounted } from "vue";


export default {
  __name: 'AvailablePoints',
  setup(__props) {

const { data: transactionData, isLoading } = useMyTransactionsQuery();

// More popover state
const morePopoverOpen = ref(false);
const moreBtn = ref(null);
const morePopoverEl = ref(null);

// Setup floating UI for more popover
const { floatingStyles: morePopoverStyles } = useFloating(
	moreBtn,
	morePopoverEl,
	{
		middleware: [offset(10), flip(), shift({ padding: 5 })],
		whileElementsMounted: autoUpdate,
	}
);

// More popover functions
const toggleMorePopover = () => {
	morePopoverOpen.value = !morePopoverOpen.value;
};

const closeMorePopover = () => {
	morePopoverOpen.value = false;
};

// Close popover when clicking outside
const handleClickOutside = (event) => {
	if (
		morePopoverOpen.value &&
		morePopoverEl.value &&
		moreBtn.value &&
		!morePopoverEl.value.contains(event.target) &&
		!moreBtn.value.contains(event.target)
	) {
		closeMorePopover();
	}
};

// Core computed properties
const availablePoints = computed(() => {
	if (!transactionData.value) return 0;
	return transactionData.value.totalPoints - transactionData.value.usedPoints;
});

const totalPoints = computed(() => {
	return transactionData.value?.totalPoints || 0;
});

const hasActiveTransactions = computed(() => {
	return transactionData.value?.transactions?.length > 0;
});

// Get all transactions sorted by expiry date (earliest first)
const sortedTransactions = computed(() => {
	if (!transactionData.value?.transactions?.length) {
		return [];
	}

	return transactionData.value.transactions
		.map((t) => {
			const validUntilDate = new Date(t.validUntil);
			return {
				...t,
				validUntilDate,
			};
		})
		.filter((t) => !isNaN(t.validUntilDate.getTime())) // Filter out invalid dates
		.sort((a, b) => a.validUntilDate - b.validUntilDate);
});

// Format date for detailed view
const formatDetailedDate = (date) => {
	const weekdays = [
		"Sonntag",
		"Montag",
		"Dienstag",
		"Mittwoch",
		"Donnerstag",
		"Freitag",
		"Samstag",
	];
	const months = [
		"Januar",
		"Februar",
		"März",
		"April",
		"Mai",
		"Juni",
		"Juli",
		"August",
		"September",
		"Oktober",
		"November",
		"Dezember",
	];

	const weekday = weekdays[date.getDay()];
	const day = date.getDate().toString().padStart(2, "0");
	const month = months[date.getMonth()];
	const hours = date.getHours().toString().padStart(2, "0");
	const minutes = date.getMinutes().toString().padStart(2, "0");

	return `${weekday}, ${day}. ${month} um ${hours}:${minutes} Uhr`;
};

// Lifecycle hooks
onMounted(() => {
	document.addEventListener("click", handleClickOutside);
});

onUnmounted(() => {
	document.removeEventListener("click", handleClickOutside);
});

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createCommentVNode(" Loading State "),
      (_unref(isLoading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
            _createStaticVNode("<div class=\"card-body p-4\"><div class=\"row align-items-center\" style=\"min-height:120px;\"><div class=\"col-5 text-center\"><div class=\"skeleton skeleton-points mb-2\" style=\"height:60px;width:80px;margin:0 auto;\"></div><div class=\"skeleton skeleton-title\" style=\"height:20px;width:60px;margin:0 auto;\"></div></div><div class=\"col-2 d-flex justify-content-center\"><div class=\"skeleton\" style=\"width:1px;height:100px;\"></div></div><div class=\"col-5\"><div class=\"skeleton skeleton-title mb-2\" style=\"height:24px;\"></div><div class=\"skeleton skeleton-time\" style=\"height:40px;\"></div></div></div></div>", 1)
          ]))]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createCommentVNode(" Main Content "),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createCommentVNode(" Available Points Section "),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(availablePoints.value), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_8, " von " + _toDisplayString(totalPoints.value) + " Punkten verfügbar ", 1 /* TEXT */)
                  ]),
                  _createCommentVNode(" Divider "),
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col-2 d-flex justify-content-center" }, [
                    _createElementVNode("div", {
                      class: "border-start",
                      style: {"height":"100px","border-width":"2px !important"}
                    })
                  ], -1 /* CACHED */)),
                  _createCommentVNode(" Points Return List "),
                  _createElementVNode("div", _hoisted_9, [
                    (hasActiveTransactions.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedTransactions.value.slice(0, 2), (transaction) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: transaction.id,
                              class: "mb-3"
                            }, [
                              _createElementVNode("div", _hoisted_11, " + " + _toDisplayString(transaction.points) + " Punkte ", 1 /* TEXT */),
                              _createVNode(_unref(VueCountdown), {
                                time: 
                    Math.max(
                      0,
                      transaction.validUntilDate.getTime() - Date.now()
                    )
                  
                              }, {
                                default: _withCtx(({ days, hours, minutes, seconds }) => [
                                  _createElementVNode("div", _hoisted_12, [
                                    _cache[1] || (_cache[1] = _createTextVNode(" In ", -1 /* CACHED */)),
                                    (days >= 2)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(days) + " Tagen", 1 /* TEXT */))
                                      : (days === 1)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, "1 Tag"))
                                        : (hours >= 1)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(hours) + " " + _toDisplayString(hours === 1 ? "Stunde" : "Stunden"), 1 /* TEXT */))
                                          : (minutes >= 1)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(minutes) + " " + _toDisplayString(minutes === 1 ? "Minute" : "Minuten"), 1 /* TEXT */))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(seconds) + " " + _toDisplayString(seconds === 1 ? "Sekunde" : "Sekunden"), 1 /* TEXT */))
                                  ])
                                ]),
                                _: 1 /* STABLE */
                              }, 8 /* PROPS */, ["time"])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */)),
                          _createCommentVNode(" Show more button if there are more than 2 transactions "),
                          (sortedTransactions.value.length > 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                _createElementVNode("button", {
                                  ref_key: "moreBtn",
                                  ref: moreBtn,
                                  type: "button",
                                  class: "btn btn-outline-secondary btn-xs",
                                  onClick: toggleMorePopover
                                }, " Alle anzeigen ", 512 /* NEED_PATCH */)
                              ]))
                            : _createCommentVNode("v-if", true)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_19, [...(_cache[2] || (_cache[2] = [
                          _createElementVNode("small", null, "Keine aktiven Buchungen", -1 /* CACHED */)
                        ]))]))
                  ])
                ])
              ])
            ])
          ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
    ]),
    _createCommentVNode(" All Transactions Popover "),
    (morePopoverOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "morePopoverEl",
          ref: morePopoverEl,
          style: _normalizeStyle([_unref(morePopoverStyles), {"z-index":"1050","max-width":"280px","max-height":"400px","overflow-y":"auto"}]),
          class: "popover-content bg-white border shadow-sm rounded p-3"
        }, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center mb-2" }, [
            _createElementVNode("h6", { class: "mb-0 fw-bold" }, " Alle Rückgaben ")
          ], -1 /* CACHED */)),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "small text-muted mb-3" }, " Ihre kommenden Punktrückgaben im Überblick: ", -1 /* CACHED */)),
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedTransactions.value, (transaction) => {
              return (_openBlock(), _createElementBlock("div", {
                key: transaction.id,
                class: "mb-3"
              }, [
                _createElementVNode("div", _hoisted_20, " + " + _toDisplayString(transaction.points) + " Punkte ", 1 /* TEXT */),
                _createElementVNode("div", _hoisted_21, _toDisplayString(formatDetailedDate(transaction.validUntilDate)), 1 /* TEXT */)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ], 4 /* STYLE */))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}